/* Categoria e catálogo

   1. "Ver mais" na descrição — só aparece se o texto realmente estourar.
   2. Ordenar — as ordenações de verdade recarregam com ?sort_by=, feitas pelo
      servidor. "Em promoção" é a exceção: não é ordenação, é filtro, e roda no
      navegador sobre a página já carregada. Por isso ela mora em ?promo=1,
      separada do sort_by, e as duas coisas convivem. */

(function () {
  'use strict';

  var PROMO = 'promo';

  function CollectionPage(root) {
    this.root = root;
    this.desc = root.querySelector('[data-coll-desc]');
    this.descText = root.querySelector('[data-coll-desc-text]');
    this.descToggle = root.querySelector('[data-coll-desc-toggle]');
    this.sort = root.querySelector('[data-coll-sort]');
    this.grid = root.querySelector('[data-coll-grid]');
    this.count = root.querySelector('[data-coll-count]');
    this.countWord = root.querySelector('[data-coll-count-word]');
    this.emptyPromo = root.querySelector('[data-coll-empty-promo]');

    this.cells = this.grid ? [].slice.call(this.grid.children) : [];
    this.totalCount = this.cells.length;

    this.initDescription();
    this.initSort();
  }

  /* ---------- Descrição recolhível ---------- */

  CollectionPage.prototype.initDescription = function () {
    if (!this.desc || !this.descText || !this.descToggle) return;
    var self = this;
    var more = this.descToggle.querySelector('[data-coll-desc-more]');
    var less = this.descToggle.querySelector('[data-coll-desc-less]');

    this.desc.setAttribute('data-collapsed', 'true');
    this.measure();

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { self.measure(); });
    }
    window.addEventListener('resize', function () { self.measure(); });

    this.descToggle.addEventListener('click', function () {
      var collapsed = self.desc.getAttribute('data-collapsed') === 'true';
      self.desc.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
      if (more) more.hidden = collapsed;
      if (less) less.hidden = !collapsed;
    });
  };

  CollectionPage.prototype.measure = function () {
    if (!this.desc || !this.descText || !this.descToggle) return;
    if (this.desc.getAttribute('data-collapsed') !== 'true') return;
    this.descToggle.hidden = this.descText.scrollHeight <= this.descText.clientHeight + 4;
  };

  /* ---------- Ordenar e filtrar ---------- */

  CollectionPage.prototype.initSort = function () {
    if (!this.sort) return;
    var self = this;

    // Promoção não vem marcada do servidor: o Liquid não enxerga a query
    // string, então quem restaura o estado ao recarregar é o próprio JS.
    var params = new URLSearchParams(window.location.search);
    if (params.get(PROMO) === '1') {
      var hasOption = !!this.sort.querySelector('option[value="' + PROMO + '"]');
      if (hasOption) this.sort.value = PROMO;
      this.applyPromo(true);
    }

    this.sort.addEventListener('change', function () {
      var url = new URL(window.location.href);

      if (this.value === PROMO) {
        url.searchParams.set(PROMO, '1');
        window.history.replaceState({}, '', url.toString());
        self.applyPromo(true);
        return;
      }

      url.searchParams.delete(PROMO);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  };

  CollectionPage.prototype.applyPromo = function (active) {
    if (!this.grid) return;
    var shown = 0;

    this.cells.forEach(function (cell) {
      var card = cell.querySelector('[data-pc]');
      var isPromo = card && card.getAttribute('data-promo') === 'true';
      var hide = active && !isPromo;
      cell.classList.toggle('is-hidden', hide);
      if (!hide) shown++;
    });

    if (this.count) this.count.textContent = active ? shown : this.totalCount;
    if (this.countWord) this.countWord.textContent = (active ? shown : this.totalCount) === 1 ? 'produto' : 'produtos';
    if (this.emptyPromo) this.emptyPromo.hidden = !(active && shown === 0);
    this.grid.hidden = active && shown === 0;
  };

  /* ---------- Montagem ---------- */

  function mount(scope) {
    var roots = (scope || document).querySelectorAll('[data-coll]');
    [].forEach.call(roots, function (root) {
      if (root.dataset.collReady === 'true') return;
      root.dataset.collReady = 'true';
      new CollectionPage(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mount(); });
  } else {
    mount();
  }

  document.addEventListener('shopify:section:load', function (e) { mount(e.target); });
})();